<template>
<div class="chapter">
<div class="inner_page">
<div id="title-page">
<div class="image3"><img alt="cbostp.eps" class="frame-1" src="images/cbostp_fmt.jpeg"/></div>
<p class="pubs"><span class="generated-style">Llewellyn Publications</span></p>
<p class="pubs"><span class="generated-style">Woodbury, Minnesota</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title_Page.vue?72849400